<template>
<div class="con">
  <el-form
    ref="form"
    label-width="200px"
    class="management"
    disabled
    v-for="(item, index) in attendanceData.pfa_list"
    :key="item.id"
    :model="attendanceData.pfa_list[index]">
    <p class="title">{{ $t('payroll_management_7', { key: index+1 }) }}</p>
    <!-- 选择人员 -->
    <el-form-item :label="$t('payroll_management_8')">
      <div class="staff">
        <div class="staff-dec">
          <el-tag
            v-for="staff in item.staff_info_ids"
            :key="staff.id"
            type="info"
            size="small">
            {{staff.staff_name}}
          </el-tag>
        </div>
        <span class="staff-info">
          {{ $t('912', { y: item.staff_info_ids.length || 0, x: item.department_id.length || 0 }) }}
        </span>
      </div>
    </el-form-item>
    <!-- 是否扣税与社保 -->
    <el-form-item
      :label="$t('payroll_management_9')">
      <!-- 计算税 -->
      {{ $t('payroll_management_10') }}  <el-switch v-model="item.is_tax" ></el-switch>
      <!-- 计算社保 -->
      {{ $t('payroll_management_11') }}  <el-switch v-model="item.is_ss" ></el-switch>
    </el-form-item>
    <!-- 发放条件 -->
    <el-form-item :label="$t('payroll_management_12')">
      <el-select v-model="item.provide_condition" multiple size="small">
        <el-option
          v-for="item in attendanceData.conditions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <p class="tip-text">{{ $t('payroll_management_13') }}</p>
    </el-form-item>
      <!-- 发放方式 -->
      <el-form-item
        :label="$t('payroll_management_12')">
        <el-radio-group v-model="item.provide_way">
          <el-radio label="0">{{ $t('1632') }}</el-radio>
          <el-radio label="1">{{ $t('payroll_management_14') }}</el-radio>
        </el-radio-group>
        <!-- 固定额度 -->
        <div v-if="item.provide_way === '0'">
          {{ $t('payroll_management_15') }}
          <span class="provide">{{ item.provide_way_0 | ThousandSeparator }}</span>
          {{ $t('payroll_management_16') }}
        </div>
        <!-- 逐月递增 -->
        <div v-if="item.provide_way === '1'" class="provide_way">
          <div v-for="(way, key , index) in item.provide_way_1" :key="key" class="provide_way_item">
            <span v-if="index === 0">{{ $t('payroll_management_17') }} </span>
            <span v-else>{{ $t('payroll_management_18', { key: index+1 }) }} </span>
            <span class="provide">{{ item.provide_way_1[key] | ThousandSeparator }}</span>
            {{ $t('payroll_management_16') }}
          </div>
        </div>
      </el-form-item>
  </el-form>

</div>
</template>

<script>
export default {
  props: {
    attendanceData: {
      type: Object
    }
  },
  filters: {
    ThousandSeparator(input) {
      return input && input.toString()
        .replace(/(^|\s)\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.con {
  border: 1px solid #D5D5D5;
  margin-top: 24px;
  .management {
    .el-form-item {
      margin-bottom: 16px;
      .tip-text {
        font-size: 14px;
        color: #8C8C8C;
      }
    }
    .provide {
      display: inline-block;
      height: 32px;
      width: 100px;
      line-height: 32px;
      background-color: #F5F7FA;
      border: 1px solid #E4E7ED;
      color: #C0C4CC;
      cursor: not-allowed;
      padding: 0 15px;
      border-radius: 4px;
    }
    .el-switch {
      margin-right: 12px;
    }
  }
  .management + .management {
    .title {
      border-top: 1px solid #D5D5D5;
    }
  }
  .title {
    height: 48px;
    line-height: 48px;
    background: #FBFBFB;
    border-bottom: 1px solid #D5D5D5;
    font-size: 14px;
    color: #262626;
    padding-left: 16px;
    margin-bottom: 24px;
  }
  .el-select {
    width: 408px;
  }
  /deep/ .el-input {
    max-width: 408px;
  }
}
.provide_way {
  &_item {
    margin-bottom: 10px;
  }
}
</style>
